import api from './api';

export interface UserRequest {
  id: string;
  userId: string;
  tenantId: string;
  requestType: 'DELETE_ACCOUNT' | 'EXPORT_DATA';
  status: 'PENDING' | 'APPROVED' | 'REJECTED' | 'COMPLETED';
  adminNotes?: string;
  createdAt: string;
  updatedAt: string;
  userEmail?: string;
  firstName?: string;
  lastName?: string;
}

export const createUserRequest = async (requestType: 'DELETE_ACCOUNT' | 'EXPORT_DATA'): Promise<UserRequest> => {
  const response = await api.post('/user-requests', { requestType });
  return response.data;
};

export const getUserRequests = async (status?: string): Promise<UserRequest[]> => {
  const response = await api.get('/user-requests', { params: { status } });
  return response.data;
};

export const updateUserRequestStatus = async (
  id: string,
  status: 'APPROVED' | 'REJECTED',
  adminNotes?: string
): Promise<UserRequest> => {
  const response = await api.put(`/user-requests/${id}/status`, { status, adminNotes });
  return response.data;
};

export const getUserMyRequests = async (): Promise<UserRequest[]> => {
  const response = await api.get('/user-requests/my-requests');
  return response.data;
};

export const getDownloadUrl = async (id: string): Promise<{ url: string }> => {
  const response = await api.get(`/user-requests/${id}/download`);
  return response.data;
};

export const archiveUserRequest = async (id: string): Promise<void> => {
  await api.put(`/user-requests/${id}/archive`);
};
